export default __webpack_public_path__ + "static/reviews-video-mark-74a826b2169e5468a0cf1f427e60574d.png";